module.exports = __webpack_public_path__ + "img/50-Of-The-Most-Beautiful-Rose-Tattoos-3.jpg";